module.exports = __webpack_public_path__ + "media/src/assets/images/area-info1-7f83acb221d83bdff79a10859e33b1a8.png";